import { useState } from "react";
import { App, AppAdd } from "@/types/app";
import { notification } from "antd";
import { appAdd } from "apis/app";
import i18next from "i18next";
import errorCodes from "@/apis/error";

type AddApp = (props: AppAdd) => Promise<App>

type IAppAdd = () => [ boolean, { addApp: AddApp } ]

const useAppAdd:IAppAdd = () => {

  const [addLoading, setAddLoading] = useState<boolean>(false)
  
  const addApp:AddApp = (props) => {
    setAddLoading(true)
    return new Promise((resolve) => {
      appAdd(props)
        .then((appInfo:App) => {
          resolve(appInfo)
          notification.success({ placement: 'top',message: i18next.t('app.addSuccess')})
        })
        .catch(err => {
          notification.error({ placement: 'top',message: errorCodes[err] || err})
        })
        .finally(() => {
          setAddLoading(false)
        })
    })
  }
 
  return [addLoading, {addApp}]
};

export default useAppAdd;